/**
 * Cliente API de stock de recursos (Sprint 17 S17-04 / UI S17-13).
 *
 * Endpoints:
 * - GET /stock-recursos/ — listado con filtros (tipo, estado).
 * - GET /stock-recursos/disponible — resumen por tipo (cantidad + valor
 *   del próximo FIFO).
 * - POST /stock-recursos/ingresar — alta de N items.
 */
import { apiFetch } from './client';
import type {
  EstadoStock,
  RecursoAsignacionDirectaIn,
  SolicitudRecursoRead,
  StockRecursoDisponibleResumen,
  StockRecursoIngresar,
  StockRecursoRead,
  TipoStock,
} from './types';

export interface ListStockFiltros {
  tipo?: TipoStock;
  estado?: EstadoStock;
}

export function listStockRecursos(
  filtros: ListStockFiltros = {},
): Promise<StockRecursoRead[]> {
  const params = new URLSearchParams();
  if (filtros.tipo) params.set('tipo', filtros.tipo);
  if (filtros.estado) params.set('estado', filtros.estado);
  const qs = params.toString();
  return apiFetch<StockRecursoRead[]>(
    `/stock-recursos/${qs ? `?${qs}` : ''}`,
  );
}

export function getStockDisponiblePorTipo(): Promise<
  StockRecursoDisponibleResumen[]
> {
  return apiFetch<StockRecursoDisponibleResumen[]>(
    '/stock-recursos/disponible',
  );
}

export function ingresarStock(
  data: StockRecursoIngresar,
): Promise<StockRecursoRead[]> {
  return apiFetch<StockRecursoRead[]>('/stock-recursos/ingresar', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/**
 * Sprint 17 S17-04b — vía de excepción D-S17-11.
 * POST /recursos/asignacion-directa
 */
export function crearAsignacionDirecta(
  data: RecursoAsignacionDirectaIn,
): Promise<SolicitudRecursoRead> {
  return apiFetch<SolicitudRecursoRead>('/recursos/asignacion-directa', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
